import React, { useEffect, ReactElement } from "react";

import { onSnapshotTrackDetails, getSessionDoc } from "../../apis/firebase";

import { trackRedux } from "../../redux";

import { useSelector, useDispatch, shallowEqual } from "react-redux";

let snapshotRef = null;

export default (): ReactElement => {
  const dispatcher = useDispatch();

  const { loggedInUser } = useSelector(
    ({ loggedInUser }) => ({ loggedInUser }),
    shallowEqual
  );

  useEffect(() => {
    if (!loggedInUser || !loggedInUser.uid || !loggedInUser.track) return;

    snapshotRef = onSnapshotTrackDetails(loggedInUser.track, async (data) => {
      data.sessions = await Promise.all(
        (!!data.sessions &&
          data.sessions.map(async (s) => ({
            ...s,
            ...(await getSessionDoc(s.sessionId)),
          }))) ||
          (data.sessionId && [...(await getSessionDoc(data.sessionId))])
      );

      dispatcher(trackRedux.actions.update_track({ ...data }));
    });

    return () => {
      snapshotRef();
    };
  }, [loggedInUser]);

  return <></>;
};
